<template>
  <v-btn
    icon
    class="bellBtn"
    :ripple="false"
    aria-label="Notifications"
    @click="redirectToNotifications"
  >
    <v-badge
      v-if="appNotification"
      :content="appNotification"
      color="#c0392b"
      overlap
      bordered
      offset-x="12"
      offset-y="12"
    >
      <v-icon size="21" color="#3f5347">mdi-bell-outline</v-icon>
    </v-badge>
    <v-icon v-else size="21" color="#3f5347">mdi-bell-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  computed: {
    appNotification() {
      return this.$store.state.notification || 0;
    },
    appUser() {
      return this.$store.state.userRole;
    },
  },
  methods: {
    redirectToNotifications() {
      if (this.appUser === "admin") {
        this.$router.push("/Admin/notifications");
      } else {
        this.$router.push("/Officers/notifications");
      }
    },
  },
};
</script>

<style scoped>
/* Matches the account pill next to it: same border, ground and hover. */
.bellBtn {
  width: 38px !important;
  height: 38px !important;
  border-radius: 999px !important;
  border: 1px solid #dfe6e1;
  background: #f7faf8;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.bellBtn:hover {
  background: #eef4f0;
  border-color: #b9cbbf;
}

.bellBtn::before {
  display: none;
}

.bellBtn ::v-deep .v-badge__badge {
  font-family: sofiaProSemiBold, "Poppins", sans-serif;
  font-size: 9px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
}
</style>
